export enum ServerErrors {
  INVALID_REQUEST = 'InvalidRequest',
  FAILED_LOGIN = 'Email or password incorrect',
  GENERAL_ERROR = 'An error occurred. Please try again!',
  NONE = '',
  BOOKING_NOT_OPEN = 'BookingNotOpen',
  NO_MORE_SEATS = 'NoMoreSeats',
  BOOKING_EXISTS = 'BookingExists',
}
